import { ImageCDNPath } from "GlobalConstant/index";
import ImageSizes from "GlobalConstant/ImageSizes";
export const DESKTOP_BANNER =
  ImageCDNPath +
  ImageSizes._0By0 +
  "/cw/static/landing-banners/banner-bs6-desktop.jpg";

export const MSITE_BANNER =
  ImageCDNPath +
  ImageSizes._0By0 +
  "/cw/static/landing-banners/banner-bs6-msite.jpg";
export const PAGE_API = "/api/bs6cars/";
export const ELECTRICCARSPAGE = "/electric-cars/";

export const EXPERTREVIEW_ENDPOINT = "/expert-reviews/";
export const FEATURES_ENDPOINT = "/features/";
export const NEWS_ENDPOINT = "/news/";

export const EXPERTREVIEW_ENDPOINT_MSITE = "/expert-reviews/";
export const FEATURES_ENDPOINT_MSITE = "/features/";
export const NEWS_ENDPOINT_MSITE = "/news/";

export const VIEW_ALL_EXPERTREVIEWS = "View All Expert Reviews";
export const VIEW_ALL_NEWS = "View All News";
export const VIEW_ALL_FEATURES = "View All Featured Stories";

export const BS6_ENDPOINT = "/new/bs6-cars/";

export const BREADCRUMB_ENTITY = [
  {
    title: "Home",
    text: "Home",
    url: "/",
  },
  { title: "CarWale New Cars", text: "New Cars", url: "/new/" },
  {
    text: "BS6 Cars",
  },
];
